export function intensityToRIR(intensity: number) {
  switch (true) {
    case intensity < 39:
      return "";
    case intensity >= 39 && intensity <= 49:
      return "(RIR 6)";
    case intensity >= 50 && intensity <= 69:
      return "(RIR 5)";
    case intensity >= 70 && intensity <= 74:
      return "(RIR 4)";
    case intensity >= 75 && intensity <= 79:
      return "(RIR 3)";
    case intensity >= 80 && intensity <= 89:
      return "(RIR 2)";
    case intensity >= 90 && intensity <= 94:
      return "(RIR 1)";
    case intensity > 95:
      return "(RIR 0)";
    default:
      return "";
  }
}
